import { Icon, Text, VStack, Link } from '@chakra-ui/react';
import { FaHeart, FaCanadianMapleLeaf } from 'react-icons/fa';

const CreatorInfo = () => {
  return (
    <VStack>
      <Text
        style={{
          letterSpacing: '1px',
        }}
      >
        Made with <Icon as={FaHeart} w={5} h={5} color="red.500" /> in{' '}
        <Icon as={FaCanadianMapleLeaf} w={6} h={6} color="red.500" /> by{' '}
        <Link href="https://dreamlotusstudio.xyz/">Dream Lotus Studio</Link>
      </Text>
      {/* <Box mt="5px">
        <Link href="https://lotusaurora.xyz/">
          <Icon boxSize={8} color="blue.800">
            <FcGlobe />
          </Icon>
          <Text as="i">Visit lotusaurora.xyz</Text>
        </Link>{' '}
      </Box> */}
    </VStack>
  );
};

export default CreatorInfo;
